<div class="subscribe-wrapper">
  <div class="subscribe-content">
    <div class="content">
      @if (!isUserInfoLoading && (hasEndedTrial || subscriptionEnded)) {
        <h2 class="text-center mt-10 mb-5">
          Please add a payment method <br />
          <span class="text-blue-700">in order to continue using BuildEvo</span>
        </h2>
        @if (hasEndedTrial) {
          <p class="text-size_xxl">Your trial has ended without any payment method added to your subscription.</p>
        }
        @if (subscriptionEnded) {
          <p class="text-size_xxl">Your don't have any payment method added to your subscription.</p>
        }
        <p class="text-size_xxl">Please click on the button below and add a payment method.</p>
        <div class="flex justify-center mt-12 mb-60">
          <app-simple-button (click)="manageSubscription()" class="landing-btn light-blue-btn uppercase">
            Add payment method
          </app-simple-button>
        </div>
      }

      @if (!isUserInfoLoading && !(hasEndedTrial || subscriptionEnded)) {
        <h2 class="text-left mt-10 mb-5">Please subscribe to a paid plan</h2>
        @if (!hasTeamSubscription) {
          <p class="text-size_xxl">
            In order to continue using Buildevo, <span class="font-semibold">you need to select a paid plan.</span>
          </p>
        }
        <p class="text-size_xxl">
          Premium plans include a one-time <span class="font-semibold">free 30-day trial.</span>
        </p>
        <div class="my-16 flex justify-center items-center gap-4">
          <app-simple-button buttonStyle="color_secondary_filled" (click)="openCheckoutPage()" size="xxl"
            >Create a Subscription</app-simple-button
          >
        </div>
      }

      @if (!isUserInfoLoading) {
        <div class="mt-10">
          <p class="text-center">
            If in doubt, please contact us at <a href="mailto:contact@buildevo.com">contact&commat;buildevo.com</a> and
            we will be happy to help.
          </p>
          <div class="button-container">
            @if (hasTeamSubscription) {
              <app-simple-button (click)="goBack()" buttonStyle="color_secondary_border">
                Go back to BuildEvo
              </app-simple-button>
            } @else {
              <app-simple-button size="large" buttonStyle="color_secondary_border" (click)="logout()"
                >Log out</app-simple-button
              >
            }
          </div>
        </div>
      }
    </div>
  </div>

  <div [ngClass]="{ animate: triggerAnimation }" class="triangle left"></div>
  <div [ngClass]="{ animate: triggerAnimation }" class="triangle right"></div>
</div>
